import React, { createContext, useContext, useEffect, useState } from "react";
import { getSettings } from "../lib/api";

const Ctx = createContext({ brand: "VC Charters", tagline: "Private Charters", whatsapp: "", email: "", phone: "", city: "" });

export function SettingsProvider({ children }) {
  const [s, setS] = useState({ brand: "VC Charters", tagline: "Private Charters", whatsapp: "", email: "", phone: "", city: "" });
  useEffect(() => { getSettings().then((d) => setS((p) => ({ ...p, ...d }))).catch(() => {}); }, []);
  return <Ctx.Provider value={s}>{children}</Ctx.Provider>;
}
export const useSettings = () => useContext(Ctx);
